jQuery(function ($) {
    function equalizeHeights() {
        // Find all elements with the class equal_height
        var $items = $('.equal_height');
        // Reset heights to auto to calculate new heights
        $items.css('height', 'auto');
        var maxHeight = 0;
        // Calculate the maximum height
        $items.each(function () {
            var height = $(this).outerHeight(true); // Get the outer height including margin
            if (height > maxHeight) {
                maxHeight = height;
            }
           
        });
       
        $items.outerHeight(maxHeight);
        const mediaQueryMob = matchMedia('(max-width: 576px)');
        if (mediaQueryMob.matches) {
            $items.css('height', 'auto');
        }
    }
    equalizeHeights();
    $(window).on('resize', equalizeHeights);
   
});

//imgae-bottom promo box  
    $('.promocontent-div').each(function () {
        if ($(this).closest('.pushbox').find('.pushbox-img').length > 0) {
            // Add a class (e.g., 'has-image') to .promocontent-div
            $(this).addClass('align_PromoImg_bottom');
        }
    });
 
